import { ChakraBox, ChakraFlex, Text } from '@equip.health/ui';
import { PatientNoteDescriptionDetailsResponse } from '~/lib/types/carePlan/carePlans';
import { isoToLocalDateTime } from '~/lib/util/date.util';
import { useProviderAvatar } from '~/lib/hooks/carePlan/useProviderAvatar';

export const CarePlanDescriptionRow = ({
  descriptionDetails,
  goalId,
}: {
  descriptionDetails: PatientNoteDescriptionDetailsResponse;
  goalId: string;
}) => {
  const { avatarWithTooltip } = useProviderAvatar({
    providerId: descriptionDetails.changedBy,
    size: 'xs',
    placement: 'left',
  });

  return (
    <ChakraFlex
      id={`care-plan-description-goal-${goalId}`}
      background="neutral.background.secondary"
      borderRadius="12px"
      alignItems="center"
      gap="10px"
      marginTop="12px"
      padding="12px"
      width="100%"
    >
      {avatarWithTooltip}
      <ChakraBox marginRight="12px" marginTop="6px" flex={1}>
        <Text variant="caption">{descriptionDetails.description}</Text>
        <Text color="neutral.secondary" marginTop="4px" variant="caption">
          {isoToLocalDateTime(descriptionDetails.effectiveDate).toFormat(
            'MMM dd, yyyy h:mm a',
          )}
        </Text>
      </ChakraBox>
    </ChakraFlex>
  );
};
